import selmaLogo from '../assets/selmalogo.svg';

const Hero = () => {
  const handleScroll = (e, target) => {
    e.preventDefault();
    const element = document.querySelector(target);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1560066984-138dadb4c035?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2000&q=80')`,
        }}
      >
        <div className="absolute inset-0" style={{ background: 'var(--overlay-dark)' }} />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto text-center text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          {/* Logo */}
          <div className="mb-6 sm:mb-8 flex justify-center">
            <img
              src={selmaLogo}
              alt="Hårgalleriet Selma Logo"
              className="w-48 sm:w-64 md:w-80 lg:w-96 h-auto opacity-90 hover:opacity-100 transition-opacity brightness-0 invert"
            />
          </div>

          {/* Subtitle */}
          {/* <p className="text-heading mb-6 opacity-90" style={{ color: 'var(--color-text-white)' }}>
            Din frisörsalong i centrala Limhamn
          </p> */}

          {/* Main Title */}
          <h1 className="mb-6 sm:mb-8">
            <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl mb-4 uppercase leading-tight">
              Din frisör på Limhamn
            </span>
          </h1>

          {/* Divider */}
          <div className="w-16 sm:w-24 h-px bg-white/50 mx-auto mb-6 sm:mb-8" />

          {/* Description */}
          {/* <p className="text-lg md:text-xl mb-12 max-w-2xl mx-auto font-light leading-relaxed opacity-90">
            Välkommen till Hårgalleriet – en exklusiv oas för allt inom hår.
            Med över 20 års erfarenhet skapar vi drömhår i en lyxig miljö.
          </p> */}

          {/* CTA Button */}
          <a href="https://www.bokadirekt.se/places/hargalleriet-selma-p-57369" target="_blank" rel="noopener noreferrer">
            <button className="btn btn-hero text-xs sm:text-sm px-6 sm:px-8 py-3 sm:py-4">
              Boka tid online
            </button>
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 sm:bottom-12 left-0 right-0 z-10 flex justify-center animate-bounce">
        <a
          href="#about"
          onClick={(e) => handleScroll(e, '#about')}
          className="flex flex-col items-center text-white opacity-70 hover:opacity-100 transition-opacity"
        >
          <span className="text-xs uppercase tracking-wider sm:tracking-widest mb-1 sm:mb-2">Scrolla</span>
          <svg
            className="w-5 h-5 sm:w-6 sm:h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </a>
      </div>
    </section>
  );
};

export default Hero;
